import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilService } from './util.service';
import { MovieService } from './movie.service';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  domain: any = '';
  username: any = '';
  password: any = '';
  url: any = '';
  Xurl: any;
  Ourl:any;
  OToken:any;
  constructor(public http: HttpClient, public utilService: UtilService,private apiPostMethod:MovieService) {
    this.Ourl = this.utilService.getOneStreamUrl();
    this.OToken = this.utilService.getOneStreamToken();
  
  }

  getDataLcal() {
    this.Xurl = this.utilService.getXstreamUrl();
    if (this.Xurl) {
      this.domain = this.utilService.getXstreamUrl();
      this.username = this.utilService.getXstreamUsername();
      this.password = this.utilService.getXstreamPassword();
    }else if(this.Ourl){
      this.domain = this.utilService.getOneStreamUrl();
    }
    else {
      this.domain = this.utilService.getFullUrl();
      this.username = this.utilService.getFullUsername();
      this.password = this.utilService.getFullPassword();
    }
    if(this.Ourl){
      this.url = this.domain + '/play/b2c/v1/';
      return this.url;
    }else{
    this.url = this.domain + '/player_api.php?username=' + this.username + '&password=' + this.password + '&action=';    
    return this.url;
    }
  }

  getRequestType(): 'get' | 'post' {
    return (localStorage.getItem('API') as 'get' | 'post') || 'get';
  }

  public getLoginUserData() {
    if(this.OToken){
      return this.http.get(this.getDataLcal()+`user-info?token=${this.OToken}`);
    }else{
      const reqType = this.getRequestType()
      if(reqType == 'post'){
        return this.apiPostMethod.postApiData()
      }else if(reqType == 'get'){
        return this.http.get(this.getDataLcal());
      }
    }
  }

}
